
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { SaasInstance } from '@/types/userRole';
import InstanceOverviewTab from './InstanceOverviewTab';
import InstanceSettingsTab from './InstanceSettingsTab';
import UsersManagementTab from './UsersManagementTab';
import PlaceholderTab from './PlaceholderTab';
import { useNavigate } from 'react-router-dom';
import { CreditCard, Hash } from 'lucide-react';
import { Button } from '@/components/ui/button';
import InstanceReferralIdsTab from './InstanceReferralIdsTab';

interface InstanceTabsProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  instance: SaasInstance;
  instanceId: string;
}

const InstanceTabs: React.FC<InstanceTabsProps> = ({ 
  activeTab, 
  setActiveTab, 
  instance,
  instanceId
}) => {
  const navigate = useNavigate();

  const handleManagePayments = () => {
    navigate(`/super-admin/instance/${instanceId}/payments`);
  };

  return (
    <div>
      <div className="flex justify-end mb-4 gap-2">
        <Button 
          onClick={() => navigate(`/super-admin/instance/${instanceId}/referral-ids`)}
          variant="outline"
          className="flex items-center gap-2"
        >
          <Hash className="h-4 w-4" />
          Manage Referral IDs
        </Button>
        <Button 
          onClick={handleManagePayments}
          variant="outline"
          className="flex items-center gap-2"
        >
          <CreditCard className="h-4 w-4" />
          Manage Payment Settings
        </Button>
      </div>
      
      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
        <TabsList className="w-full grid grid-cols-6">
          <TabsTrigger value="overview">Overview</TabsTrigger>
          <TabsTrigger value="users">Users</TabsTrigger>
          <TabsTrigger value="settings">Settings</TabsTrigger>
          <TabsTrigger value="domains">Domains & Limits</TabsTrigger>
          <TabsTrigger value="referrals">Referral IDs</TabsTrigger>
          <TabsTrigger value="logs">Logs</TabsTrigger>
        </TabsList>
        
        <TabsContent value="overview" className="space-y-6">
          <InstanceOverviewTab instance={instance} />
        </TabsContent>
        
        <TabsContent value="users" className="space-y-6">
          <UsersManagementTab instanceId={instanceId} />
        </TabsContent>
        
        <TabsContent value="settings" className="space-y-6">
          <PlaceholderTab 
            title="Instance Settings" 
            description="Configure instance settings" 
          />
        </TabsContent>
        
        <TabsContent value="domains" className="space-y-6">
          <InstanceSettingsTab instanceId={instanceId} />
        </TabsContent>
        
        <TabsContent value="referrals" className="space-y-6">
          <InstanceReferralIdsTab instanceId={instanceId} instance={instance} />
        </TabsContent>
        
        <TabsContent value="logs" className="space-y-6">
          <PlaceholderTab 
            title="Activity Logs" 
            description="View activity history for this instance" 
          />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default InstanceTabs;
